const ConfigPropId = {
    AccountGroupName: 0,
    CreditHoldMessage: 1,
    CustomerServicePhoneNumber: 2,
    DisplayAccountNameOnMasterPage: 3,
    DisplayBackupCSREmail: 4,
    DisplayCouponCodeField: 5,
    DisplayRegisterLink: 6,
    DisplayPrimaryCSREmail: 7,
    DisplayGSALink: 8,
    EnableLoginPageEmailTextLogic: 9,
    ExpressCheckout: 10,
    GroupConfigId: 11,
    IncludeTaxForOrdersAwaitingApproval: 12,
    RequireAttentionField: 13,
    RequirePhoneNumberField: 14,
    RequireSpecialInstructionsField: 15,
    DefaultOnlineSortOrderOfAddresses: 16,
    OrderHistoryScope: 17,
    PermitAutoLogin: 18,
    PreventWorkFlowCheckout: 19,
    RelabelExpenseAllocation: 20,
    RelabelPo: 21,
    SaveUserSearches: 22,
    ShowPoNumber: 23,
    StopWebOrders: 24,
    UsePunchout: 25,
    MobileSiteDirectory: 26,
    DisplayQuantityShipped: 27,
    ManageGroupLists: 28,
    DisplayApproverOnOrderConfirmation: 29,
    WorkflowMessageOnOrderConfirmation: 30,
    DisplayCreditCardDeclineReason: 31,
    ManagePersonalCreditCard: 32,
    SavePersonalCardText: 33,
    CreditCardImageFile: 34,
    POValidationExpression: 35,
    GSALinkText: 36,
    PreventCheckoutMessage: 37,
    DisplayInstantRegistration: 38,
    PermitMobileTypeAhead: 39,
    TypeAheadRegex: 40,
    OutForDeliveryStatusText: 41,
    NotOutForDeliveryStatusText: 42,
    QuantityMaxDigits: 43,
    AllowDecimalQuantities: 44,
    DisplayDeliveryNotification: 45,
    PackingReturnTextforStepThree: 46,
    ReturnDaysThreshold: 47,
    RequirePickupInstructionsField: 48,
    ReorderQuantityLimitMessage: 49,
    DisplayCartDropdown: 50,
    PermitOnlineReturns: 51,
    DisplayOptiontoReplaceReturnItem: 52,
    AccountTypeHelpHtml: 53,
    RoutingNumberHelpHtml: 54,
    AccountNumberHelpHtml: 55,
    CheckingAccountMaxPaymentThreshold: 56,
    OfficeInteriorsLogo: 57,
    EnableMyWBRecentItemsPage: 58,
    DashboardFooterHTML: 59,
    ChatWidgetText: 60,
    DashboardEmbeddedWebChatID: 61,
    ManagePersonalChecking: 62,
    DisplayDashboardInfoPopup: 63,
    DashboardMainReportURL: 64,
    DisplayDeliveryDetailsLink: 65,
    DeliverySignatureUnavailableMessage: 66,
    EnableDashboardReport: 67,
    DefaultCustomerServiceRepImage: 68,
    DefaultSalesRepImage: 69,
    DisplayDashboardGroupingOptions: 70,
    MyWBDashboardLogo: 71,
    DeliveryStatusEndpoint: 72,
    DefaultDashboardGroupingOption: 73,
    DisplayDriverNoteonDeliveryDetails: 74,
    DisplaySignedByonDeliveryDetails: 75,
    InvoiceAsPDF: 76,
    InvoiceAsPDFInfoHTML: 77,
    RequirePhoneNumberOnWeb: 78,
    DefaultSortOrderMyWB: 79,
    DashboardDeliveryHeaderText: 80,
    DisplayDashboardDeliverySection: 81,
    DisplayDashboardAccountSection: 82,
    MobileDashboardFooterHTML: 83,
    DefaultSortOrderDashboardMyWB: 84,
    CustomerServiceRepTitle: 85,
    EnableDashboard: 86,
    MyWBContactUsImage: 87,
    ContactUsMiddleHeaderText: 88,
    ContactUsTopHeaderText: 89,
    EnableCafeXWebChat: 90,
    ContactUsEmbeddedWebChatId: 91,
    DisplaySearchBarOnContactUs: 92,
    ContactUsSearchBarHeader: 93,
    CustomerServicePageSideHTML: 94,
    ContactUsSearchBarReplacementText: 95,
    CustomerServiceEmail: 96,
    CustomerServicePhoneNumberSmall: 97,
    DashboardReturnsHTML: 98,
    MyWBMobileLogo: 99,
    MobileDashboardReturnsHTML: 100,
    WriteCustAccountToContactPersonOnLogin: 101,
    WorkflowAdminPageHeader: 102,
    RenameSpecialInstructions: 103,
    RequireCardID: 104,
    BusinessHoursDefaultText: 105,
    BusinessHoursHeaderText: 106,
    DisplayBusinessHours: 107,
    DisplaySpecialRequestDeliveryDate: 108,
    SpecialRequestDeliveryDateText: 109,
    ManageCostCenters: 110,
    AssignAllCostCenters: 111,
    DefaultExpenseTrackingFieldSet: 112,
    MyWBDashboardBanner: 113,
    AbilityToSetPaperlessStatus: 114,
    InvoiceNotificationFrequency: 115,
    OIPermissionID: 116,
    OIProhibitSignup: 117,
    DeactivatePaperlessConfirmBillingHTML: 118,
    GoPaperlessInvoicePreferencesHTML: 119,
    ManageRecurringPayments: 120,
    DollarAmountHelpHTML: 121,
    UpcomingPaymentsHelpHTML: 122,
    CancelPaymentHelpHTML: 123,
    CancelSubscriptionHelpHTML: 124,
    OneSubscriptionPerCustomer: 125,
    ARTitle: 126,
    ARPhoneNumber: 127,
    EnableDeliveryImages: 128,
    DisplayDeliveryImageUnavailableMessage: 129,
    DeliveryImageUnavailableText: 130,
    EnableDashboardFeedback: 131,
    DashboardDeliveryFeedbackGUID: 132,
    KitPopupErrorMessage: 133,
    WorkflowEditNotAllowedMessage: 134,
    AllowEditOrderApprovalWorkflows: 135,
    AllowEditEmailNotificationWorkflows: 136,
    AllowEditPreventCheckoutWorkflows: 137,
    RecurringCCAgreement: 138,
    RecurringACHAgreement: 139,
    EnableDeliveryCharges: 140,
    MobileRegZipCodeCustomHTML: 141,
    InternalUserDisplayProductSource: 142,
    DisplayAddressWhileShopping: 143,
    DisplayAddressWhileMobileShopping: 144,
    ChangeCartAddressCustomHTMLMobile: 145,
    DisplayLoginGuestPopupGate: 146,
    DisplayShoppingForOnRegistration: 147,
    DisplayAvailability: 148,
    DisplayAvailabilityServiceMessage: 149,
    OnlineReturnsMaxAmount: 150,
    OnlineReturnsAmountValidationMessage: 151,
    DisplayOpenBillingFields: 152,
    ManageShippingAddresses: 153,
    EnableAllSalesFinal: 154,
    AllSalesFinalText: 155,
    AllSalesFinalSubText: 156,
    ProductAvailabilityAPIName: 157,
    EnableBSAnalyticsTracking: 158,
    EnableOptionalChildLines: 159,
    DisplayIndividualUnitPrice: 160,
    EnableReactUserRegistration: 161,
    CouponCustomerLimitMessage: 162,
    CouponQtyLimitMessage: 163,
    CenterStageMerchandisingZone: 164,
    UseExternalIdentityProvider: 165,
    DisableMobileSiteHomepage: 166,
    EnableResponsiveMobileSearchResults: 167,
    EnableResponsiveSdsSearch: 168
};
export default ConfigPropId;